import algoliaSearch from 'algoliasearch/lite'
import qs from 'qs'
import PropTypes from 'prop-types'
import { InstantSearch } from 'react-instantsearch-dom'
import { useEffect, useRef, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

const searchClient = algoliaSearch(
  process.env.ALGOLIA_APPLICATION_ID,
  process.env.ALGOLIA_SEARCH_ONLY_KEY
)

const algoliaEnv = process.env.ALGOLIA_ENV
const videosIndex = `videos_${algoliaEnv}`

// Omit `page` from search state
const createURL = ({ page, ...searchState }) => `?${qs.stringify(searchState)}`

// https://www.algolia.com/doc/guides/building-search-ui/going-further/routing-urls/react/
const urlToSearchState = location => qs.parse(location.search.slice(1))
const searchStateToUrl = searchState =>
  searchState ? createURL(searchState) : ''

const searchDebounce = 400

export default function VideosSearchConfig({ children }) {
  const history = useHistory()
  const location = useLocation()

  const [searchState, setSearchState] = useState(urlToSearchState(location))
  const setStateId = useRef()

  const onSearchStateChange = updatedSearchState => {
    clearTimeout(setStateId.current)

    setStateId.current = setTimeout(() => {
      // Set the query params with the search term, if any; otherwise, clear the query params
      history.push({
        search: updatedSearchState.query
          ? searchStateToUrl(updatedSearchState)
          : null,
      })
    }, searchDebounce)

    return setSearchState(updatedSearchState)
  }

  // Sync the search state on location changes.
  // This handles clearing the search state when clicking away from results,
  // as well as syncing the search state when browser back/forward buttons are used.
  useEffect(() => {
    setSearchState(urlToSearchState(location))
  }, [location])

  return (
    <InstantSearch
      indexName={videosIndex}
      onSearchStateChange={onSearchStateChange}
      searchClient={searchClient}
      searchState={searchState}
      createURL={createURL}
    >
      {children}
    </InstantSearch>
  )
}

VideosSearchConfig.propTypes = {
  children: PropTypes.node.isRequired,
}
